import { useState } from "react";
import { Minus, Plus } from "lucide-react";
import { useLanguage } from "./LanguageProvider";
import { track } from "../lib/analytics";
import { SectionHeading } from "./ui";

export function FAQ() {
  const { copy } = useLanguage();
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  function toggle(index: number) {
    const willOpen = openIndex !== index;
    setOpenIndex(willOpen ? index : null);
    track("faq_interaction", { index, action: willOpen ? "open" : "close" });
  }

  return (
    <section className="section faq" id="faq">
      <div className="container faq-grid">
        <SectionHeading eyebrow={copy.faq.eyebrow} title={copy.faq.title} />
        <div className="accordion">
          {copy.faq.items.map(([question, answer], index) => {
            const open = openIndex === index;
            const answerId = `faq-answer-${index}`;
            return (
              <div className="faq-item" key={question}>
                <h3>
                  <button
                    aria-expanded={open}
                    aria-controls={answerId}
                    onClick={() => toggle(index)}
                  >
                    <span>{question}</span>
                    {open ? <Minus aria-hidden="true" /> : <Plus aria-hidden="true" />}
                  </button>
                </h3>
                <div id={answerId} className="faq-answer" hidden={!open}>
                  <p>{answer}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
